export default __webpack_public_path__ + "static/media/email.f047dd33.png";